(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBar = document.querySelector('.announcement-bar');
  const closeButton = document.querySelector('.announcement-bar__close');

  closeButton.addEventListener('click', event => {
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    slideUp(announcementBar, 300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-product-slider"] && !Shopify.designMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.product-slider__collection')].forEach((el, i) => {
    var handle = '#collection--' + el.dataset.collection;

    productSliders[i] = new Swiper(handle, { 
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: 20,
      watchOverflow: true,
      allowTouchMove: true,
      speed: 400,
      freeMode: true,
      navigation: {
        prevEl: handle + '-arrow-left',
        nextEl: handle + '-arrow-right'
      },
      scrollbar: {
        el: handle + '-scrollbar',
        draggable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          freeMode: false
        },
        1300: {
          slidesPerView: 3,
          allowTouchMove: false,
          freeMode: false
        },
        1500: {
          slidesPerView: 4.1,
          allowTouchMove: false,
          freeMode: false
        }
      }
    });
  });
  
  // Tab change
  [...document.querySelectorAll('.product-slider__navigation-item')].forEach((el, i) => {
    el.addEventListener('click', event => {
      const el = event.target;
      const collection = el.dataset.collection;

      if (!el.classList.contains('active')) {
        document.querySelector('.product-slider__navigation-item.active').classList.remove('active');
        el.classList.add('active');

        document.querySelector('.product-slider__arrows-wrapper.active').classList.remove('active');
        document.querySelector(`.product-slider__arrows-wrapper[data-collection="${collection}"]`).classList.add('active'); 

        document.querySelector('.product-slider__collection.active').classList.remove('active');
        document.querySelector(`.product-slider__collection[data-collection="${collection}"]`).classList.add('active'); 
      }
    }); 
  });
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-related"]) return;
  try {
    
const relatedSlider = new Swiper('.related-articles__container', {
  slidesPerView: 1.08,
  loop: false,
  spaceBetween: 20,
  allowTouchMove: true,
  freeMode: true,
  speed: 600,
  navigation: {
    prevEl: '.related-articles .swiper-button-prev',
    nextEl: '.related-articles .swiper-button-next'
  },
  scrollbar: {
    el: '.related-articles__scrollbar',
    draggable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      loop: true,
      allowTouchMove: false,
      freeMode: false
    }
  } 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  const cartUpsellSlider = document.querySelector('.cart-drawer__upsell-items');
  if(cartUpsellSlider) {
    const cartUpsellSwiperInstance = new Swiper(cartUpsellSlider, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 10,
      navigation: {
        prevEl: '.cart-upsell-arrow-left',
        nextEl: '.cart-upsell-arrow-right'
      },
      breakpoints: {
        501: {
          slidesPerView: 2,
        }
      }
    })
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-blocks"] && !Shopify.designMode) return;
  try {
     
  const categorySlider = new Swiper('.category-blocks__container.swiper', {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 20,
    allowTouchMove: true,
    freeMode: true,
    speed: 600,
    scrollbar: {
      el: '.category-blocks .swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        loop: true,
        allowTouchMove: false,
        freeMode: false
      }
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Credits
  const creditsButtons = document.querySelectorAll('a[href="#credits"]');
  const creditsCloseButtons = document.querySelectorAll('.site-credits__close');
  const credits = document.querySelector('.site-credits');

  creditsButtons.forEach(creditsButton => {
    creditsButton.addEventListener('click', event => {
      event.preventDefault();
      credits.classList.add('is-visible');

      document.addEventListener('keydown', function(event){
        if (event.key === "Escape") {
          credits.classList.remove('is-visible');
        }
      });
    });
  });

  creditsCloseButtons.forEach(creditsCloseButton => {
    creditsCloseButton.addEventListener('click', event => {
      credits.classList.remove('is-visible');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Megamenu Overlay
  const menuItems = document.querySelectorAll('.header__mega-menu-wrapper');
  const pageOverlay = document.querySelector('.page-overlay-under-menu');
  const megaMenuColumns = document.querySelectorAll(".header__mega-menu-group");
  menuItems.forEach(menuItem => {
    menuItem.addEventListener('mouseenter', event => {
      pageOverlay.classList.add('is-visible');
    });

    menuItem.addEventListener('mouseleave', event => {
      pageOverlay.classList.remove('is-visible');
    });
  });

  if (megaMenuColumns) {
    megaMenuColumns.forEach( c => {
      c.style.setProperty('min-width', `${c.offsetWidth + 20}px`)
    })
  }

  // Search
  const openSearch = document.querySelector('.js-open-search');
  const search = document.querySelector('.header__search-form');
  
  openSearch.addEventListener('click', event => {
    event.preventDefault();
    openSearch.style.display = 'none';
    search.classList.add('active');
    document.querySelector("input.header__search-input").focus()

    document.querySelector(".outer-header-wrapper").setAttribute("data-search-open", true)
  });

  document.querySelector(".header__search-form").addEventListener("focusout", () => {
    // If focus is still in the form, do nothing
	  if (document.querySelector(".header__search-form").contains(event.relatedTarget)) return;
    document.querySelector(".outer-header-wrapper").removeAttribute("data-search-open")
    search.classList.remove('active');
    openSearch.style.removeProperty('display')
  })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const heroSlider = document.querySelector('.hero-image-text__images.slider');

  if (heroSlider) {
    let heroSliderInstance = {};
    const settingsSlider = {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      allowTouchMove: false,
      autoplay: {
        delay: 3000,
      }
    }
  
    window.addEventListener('load', heroSwiperOnLoadOrResize);
    window.addEventListener('resize', heroSwiperOnLoadOrResize);
  
    function heroSwiperOnLoadOrResize() {
      if (window.innerWidth > 768) {
        if (heroSlider.classList.contains('swiper-initialized')) {
          heroSliderInstance.destroy({
            deleteInstance: true,
            cleanStyles: true
          });
        }
      } else {
        if (!heroSlider.classList.contains('swiper-initialized')) {
          heroSliderInstance = new Swiper('.hero-image-text__images.slider', settingsSlider);
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupCloseButtons = document.querySelectorAll('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupCloseButtons.forEach(legalPopupClose => {
    legalPopupClose.addEventListener('click', event => {
      const day = legalPopup.dataset.day;
  
      legalPopup.classList.remove('is-visible');
      setCookie('legalCookie', true, day);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
     
  const categorySlider = new Swiper('.logo__container.swiper', {
    slidesPerView: 3,
    loop: false,
    spaceBetween: 10,
    allowTouchMove: true,
    freeMode: true,
    speed: 600,
    breakpoints: {
      768: {
        slidesPerView: 6,
        loop: false,
        spaceBetween: 30
      }
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"]) return;
  try {
    
  // Handle opening / closing dropdowns
  const colorButton = document.querySelector('.product__swatches-button');
  if (colorButton) {
    colorButton.addEventListener('click', event => {
      colorButton.classList.toggle('active');
    });
  }

  const dropdownButtons = document.querySelectorAll('.product-form__input-button');
  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      dropdownButton.classList.toggle('active');
    });
  });

  const variantButtons = document.querySelectorAll('.product-form__input input[type="radio"]');
  variantButtons.forEach(variantButton => {
    variantButton.addEventListener('click', event => {
      dropdownButtons.forEach(dropdownButton => {
        dropdownButton.classList.remove('active');
      });
    });
  });

  // Show bar after scroll
  let negativeHeight = 320;
  if (window.innerWidth < 768) {
    negativeHeight = 500;
  }
  const productSectionHeight = document.querySelector('.product').offsetHeight - negativeHeight - 100;
  const headroom = new Headroom(document.querySelector('.product-bar'), { offset: productSectionHeight });
  headroom.init();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            const recommendationsSlider = new Swiper('.product-recommendations__container', {
              slidesPerView: 'auto',
              loop: false,
              spaceBetween: 4,
              watchOverflow: true,
              allowTouchMove: true,
              speed: 400,
              freeMode: true,
              navigation: {
                prevEl: '.product-recommendations .swiper-button-prev',
                nextEl: '.product-recommendations .swiper-button-next'
              },
              scrollbar: {
                el: '.product-recommendations .swiper-scrollbar',
                draggable: true
              },
              breakpoints: {
                768: {
                  loop: true,
                  freeMode: false,
                  allowTouchMove: false,
                  spaceBetween: 10,
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 4,
                  loop: true,
                  allowTouchMove: false,
                  freeMode: false,
                  spaceBetween: 10,
                },
                1440: {
                  slidesPerView: 4,
                  loop: true,
                  allowTouchMove: false,
                  freeMode: false,
                  spaceBetween: 10,
                }
              }
            });

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.product-slider__collection')].forEach((el, i) => {
    var handle = '#collection--' + el.dataset.collection;

    productSliders[i] = new Swiper(handle, { 
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: 4,
      watchOverflow: true,
      allowTouchMove: true,
      speed: 400,
      freeMode: true,
      navigation: {
        prevEl: handle + '-arrow-left',
        nextEl: handle + '-arrow-right'
      },
      scrollbar: {
        el: handle + '-scrollbar',
        draggable: true
      },
      breakpoints: {
        768: {
          freeMode: false,
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          loop: true,
          allowTouchMove: false,
          freeMode: false,
          spaceBetween: 10,
        },
        1440: {
          slidesPerView: 4,
          loop: true,
          allowTouchMove: false,
          freeMode: false,
          spaceBetween: 10,
        }
      }
    });
  });
  
  // Tab change
  [...document.querySelectorAll('.product-slider__navigation-item')].forEach((el, i) => {
    el.addEventListener('click', event => {
      const el = event.target;
      const collection = el.dataset.collection;

      if (!el.classList.contains('active')) {
        document.querySelector('.product-slider__navigation-item.active').classList.remove('active');
        el.classList.add('active');

        document.querySelector('.product-slider__arrows-wrapper.active').classList.remove('active');
        document.querySelector(`.product-slider__arrows-wrapper[data-collection="${collection}"]`).classList.add('active'); 

        document.querySelector('.product-slider__collection.active').classList.remove('active');
        document.querySelector(`.product-slider__collection[data-collection="${collection}"]`).classList.add('active'); 
      }
    }); 
  });
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-numbers"] && !Shopify.designMode) return;
  try {
     
    
  const numberSlider = new Swiper('.the__numbers-container.swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    allowTouchMove: true,
    freeMode: true,
    navigation: {
      prevEl: '.the__numbers .swiper-button-prev',
      nextEl: '.the__numbers .swiper-button-next',
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      }
    } 
  });


  } catch(e) { console.error(e); }
})();
})();
